module.exports = __webpack_public_path__ + "static/media/Cybertruck_Mobile_BackgroundPic.d3fa437d.jpg";